import {
  MultiLineChart,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${MultiLineChart.Styled.Plot} {
    height: 300px;
  }
`;

export const ChartTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChartTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.span`
  ${typographyV2.uiSm};
  color: var(--text-default);
`;

export const TitleText = styled.span`
  ${typographyV2.uiXs};
  color: var(--text-soft);
`;

export const WindowDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  background: var(--surface-default);
  padding: 0 8px;
`;

export const LegendItemVector = styled.div<{ $color: string }>`
  height: 0;
  width: 16px;
  border-top: 1px solid ${({ $color }) => $color};
`;

export const SingleLegendItemLabel = styled.span`
  ${typographyV2.bodyBase};
`;

export const EtfName = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const EtfTag = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '400px',
        borderRadius: '8px',
      },
    },
  ],
})`
  margin-top: 8px;
`;

export const MultipleLegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MultipleLegend = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EtfLegendItem = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding-top: 2px;
`;

export const EtfDetails = styled.div`
  display: flex;
  flex-direction: column;
`;
